const coupons = () => import('@/views/main/cash-coupons/cash-coupons.vue')
export default {
  path: '/main/coupons',
  name: 'coupons',
  component: coupons,
  children: []
}
